(function () {
  "use strict";

  var config = window.gymskynsAnalytics || {};
  var STORAGE_KEY = "gymskyns_cookie_consent";

  function getConsent() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — consent just won't persist across visits. */
    }
  }

  function loadGA4(id) {
    if (!id || window.__gymskynsGA4Loaded) return;
    window.__gymskynsGA4Loaded = true;

    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(id);
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", id);
  }

  function loadMetaPixel(id) {
    if (!id || window.__gymskynsPixelLoaded) return;
    window.__gymskynsPixelLoaded = true;

    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */

    window.fbq("init", id);
    window.fbq("track", "PageView");
  }

  function loadAnalytics() {
    loadGA4(config.ga4);
    loadMetaPixel(config.metaPixel);
  }

  // No banner configured at all — nothing gating analytics, load right away.
  if (!config.cookieBannerEnabled) {
    loadAnalytics();
    return;
  }

  var consent = getConsent();
  if (consent === "accepted") loadAnalytics();

  var banner = document.getElementById("cookieBanner");
  if (!banner) return;

  if (!consent) {
    banner.classList.add("is-visible");
    // Push the floating scroll-top/WhatsApp buttons up so the banner doesn't
    // sit on top of them. The banner's height is already final as soon as
    // it's in the DOM — only its position (transform) animates — so this
    // doesn't need to wait for the slide-in transition to finish.
    document.documentElement.style.setProperty("--cookie-banner-height", banner.offsetHeight + "px");
    document.body.classList.add("has-cookie-banner");

    window.addEventListener("resize", function () {
      if (banner.classList.contains("is-visible")) {
        document.documentElement.style.setProperty("--cookie-banner-height", banner.offsetHeight + "px");
      }
    });
  }

  function dismiss() {
    banner.classList.remove("is-visible");
    document.body.classList.remove("has-cookie-banner");
  }

  var acceptBtn = banner.querySelector("[data-cookie-accept]");
  var declineBtn = banner.querySelector("[data-cookie-decline]");

  if (acceptBtn) {
    acceptBtn.addEventListener("click", function () {
      setConsent("accepted");
      dismiss();
      loadAnalytics();
    });
  }

  if (declineBtn) {
    declineBtn.addEventListener("click", function () {
      setConsent("declined");
      dismiss();
    });
  }
})();
